import i18next from 'i18next';

i18next.addResources('es', 'DeleteModal', {
  text: '¿Estás seguro que querés eliminar al usuario?',
  confirm: 'Confirmar',
  cancel: 'Cancelar'
});
